module.exports = __webpack_public_path__ + "static/media/collage_7.2a7784f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/collageGame/collage_7.jpg
// module id = 2261
// module chunks = 0